// src/api/api.js
import axios from 'axios';
import { handleApiAuthError } from './apiAuthError';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

const normalizeComersBaseUrl = (rawBaseUrl) => {
  const withoutTrailingSlash = trimTrailingSlash(rawBaseUrl);
  const withoutChannelSuffix = withoutTrailingSlash.replace(/\/(retail|comers|website)$/i, '');
  const withoutApiSuffix = withoutChannelSuffix.replace(/\/api$/i, '');

  return `${withoutApiSuffix}/comers`;
};

const normalizeAuthBaseUrl = (rawBaseUrl) => {
  const withoutTrailingSlash = trimTrailingSlash(rawBaseUrl);
  const withoutChannelSuffix = withoutTrailingSlash.replace(/\/(retail|comers|website)$/i, '');

  if (withoutChannelSuffix.endsWith('/api')) {
    return withoutChannelSuffix;
  }

  return `${withoutChannelSuffix}/api`;
};

const api = axios.create({
  baseURL: normalizeComersBaseUrl(BASE_URL),
});

export const authApi = axios.create({
  baseURL: normalizeAuthBaseUrl(BASE_URL),
});

const isMobileFlowPath = () => window.location.pathname.startsWith('/m/');

const getStoredAccessToken = () => {
  const tempToken = localStorage.getItem('temp_authToken');
  const regularToken = localStorage.getItem('authToken');

  if (isMobileFlowPath()) {
    return tempToken || regularToken;
  }

  return regularToken;
};

// Interceptor para incluir el token
// En mobile puede usar token temporal; en desktop siempre usa la sesión del vendedor.
api.interceptors.request.use((config) => {
  const token = getStoredAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleApiAuthError(error);
    return Promise.reject(error);
  }
);

export default api;
